import { memo, useRef } from 'react'

import { AbsolutePopup, IPopupMethods, PopPaper } from 'core-components/library/popup'

import { FilterConfig, FilterValue } from '../../types'
import { FilterChip } from '../filterChip'

import styles from './OverflowChips.module.scss'

interface FilterEntry {
  id: string
  value: FilterValue
}

interface OverflowChipsProps {
  filters: FilterEntry[]
  config: FilterConfig[]
  onFilterChange: (filterId: string, value: FilterValue) => void
  onFilterRemove: (filterId: string) => void
}

export const OverflowChips = memo<OverflowChipsProps>(
  ({ filters, config, onFilterChange, onFilterRemove }) => {
    const popupRef = useRef<IPopupMethods>(null)

    const getConfigById = (id: string): FilterConfig | undefined => {
      return config.find((c) => c.id === id)
    }

    if (filters.length === 0) return null

    return (
      <AbsolutePopup
        ref={popupRef}
        rootClassName={styles.root}
        popupClassName={styles.popup}
        popupContent={() => (
          <PopPaper className={styles.popPaper}>
            <div className={styles.chipsList}>
              {filters.map((filter) => {
                const filterConfig = getConfigById(filter.id)
                if (!filterConfig) return null

                return (
                  <FilterChip
                    key={filter.id}
                    config={filterConfig}
                    value={filter.value}
                    onChange={(newValue) => onFilterChange(filter.id, newValue)}
                    onRemove={() => onFilterRemove(filter.id)}
                  />
                )
              })}
            </div>
          </PopPaper>
        )}
      >
        <button className={styles.moreButton} type="button">
          +{filters.length}
        </button>
      </AbsolutePopup>
    )
  }
)

OverflowChips.displayName = 'OverflowChips'
